import { inject, Injectable } from '@angular/core';
import { VerificationVerifyingModel } from '../model';
import { GenericApiService } from '@core/generic-api/data-access';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VerificationApiService {
  private readonly ENDPOINT = 'case-application-external';
  private readonly SEND_OTP = 'otp';
  private readonly VERIFY = 'verify';
  private readonly api = inject(GenericApiService);

  sendingOtp(data: VerificationVerifyingModel): Observable<{ maskPhone: string }> {
    return this.api.post(this.ENDPOINT + '/' + this.SEND_OTP, VerificationVerifyingModel.fromJson(data));
  }

  verifyingApplicant(data: VerificationVerifyingModel): Observable<string> {
    return this.api.post(this.ENDPOINT + '/' + this.VERIFY, VerificationVerifyingModel.fromJson(data));
  }
}
